"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlInputField = void 0;
var react_1 = __importDefault(require("react"));
var TextInputField_1 = require("./TextInputField");
var formik_1 = require("formik");
var DEFAULT_PREFIX = "https://";
var VALID_PREFIXES = [DEFAULT_PREFIX, "http://"];
var removePrefix = function (str, hasPrefix, prefixToAdd) {
    var removeExpectedPrefix = hasPrefix
        ? str.replace(prefixToAdd || "", "")
        : str;
    // if after removing the prefix we knew about there was another "://"
    var splitValue = removeExpectedPrefix.split("://");
    return splitValue.pop();
};
var UrlInputField = function (props) {
    var setFieldValue = (0, formik_1.useFormikContext)().setFieldValue;
    var handleKeyDown = function (e) {
        var valueIsPrefix = VALID_PREFIXES.some(function (prefix) { return e.target.value === prefix; });
        if (e.key === "Backspace" && valueIsPrefix) {
            setFieldValue(props.name, "");
        }
    };
    var appendPrefix = function (inputValue) {
        if (inputValue === "")
            return setFieldValue(props.name, "");
        var currentPrefix = VALID_PREFIXES.find(function (prefix) {
            return inputValue.startsWith(prefix);
        });
        var hasPrefix = !!currentPrefix;
        var enteredPrefix = VALID_PREFIXES.find(function (prefix) {
            return inputValue.endsWith(prefix);
        });
        if (hasPrefix && !!enteredPrefix)
            return setFieldValue(props.name, enteredPrefix);
        var cleanInput = removePrefix(inputValue, hasPrefix, currentPrefix);
        if (!hasPrefix || inputValue !== cleanInput) {
            return setFieldValue(props.name, "".concat(hasPrefix ? currentPrefix : DEFAULT_PREFIX).concat(cleanInput));
        }
        setFieldValue(props.name, inputValue);
    };
    return (react_1.default.createElement(TextInputField_1.TextInputField, __assign({}, props, { onChange: function (e) { return appendPrefix(e.target.value); }, onKeyDown: function (e) { return handleKeyDown(e); } })));
};
exports.UrlInputField = UrlInputField;
